module.exports = __webpack_public_path__ + "media/npc_dota_hero_lycan.45cda1ba.webm";